export default __webpack_public_path__ + "static/7-c3f13e5e2a4fc28bbc9ac5f479bd7474.png";